import { render, staticRenderFns } from "./bank-relationship-onboarding.vue?vue&type=template&id=a4dc818e&"
import script from "./bank-relationship-onboarding.vue?vue&type=script&lang=js&"
export * from "./bank-relationship-onboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4dc818e')) {
      api.createRecord('a4dc818e', component.options)
    } else {
      api.reload('a4dc818e', component.options)
    }
    module.hot.accept("./bank-relationship-onboarding.vue?vue&type=template&id=a4dc818e&", function () {
      api.rerender('a4dc818e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/bank-relationship-onboarding.vue"
export default component.exports